module.exports = {
      id: "mobile-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-6b422ea7dc08f55780ae3689062e9e73.svg#mobile",
      toString: function () {
        return this.url;
      }
    }